module.exports = __webpack_public_path__ + "img/13.7a9e8be5.gif";